class ProductCardGallery extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.gallery-slides');
    this.slides = Array.from(this.querySelectorAll('.gallery-slide'));
    this.progressBars = Array.from(this.querySelectorAll('.gallery-progress-bar'));
    this.currentIndex = 0;
    this.isHovering = false;
    this.hoverTimeout = null;
    
    if (this.slides.length <= 1) return;

    // Attach events to closest .card__inner ancestor
    this.cardInner = this.closest('.product-card-wrapper');
    if (this.cardInner) {
      this.bindEventsToCardInner();
    } else {
      this.bindEvents(); // fallback to old behavior if .card__inner not found
    }
  }

  bindEventsToCardInner() {
    this.cardInner.addEventListener('mouseenter', () => {
      this.isHovering = true;
      this.startGallery();
    });

    this.cardInner.addEventListener('mouseleave', () => {
      this.isHovering = false;
      this.resetGallery();
    });
  }

  bindEvents() {
    this.addEventListener('mouseenter', () => {
      this.isHovering = true;
      this.startGallery();
    });

    this.addEventListener('mouseleave', () => {
      this.isHovering = false;
      this.resetGallery();
    });
  }

  startGallery() {
    if (this.slides.length <= 1) return;

    this.showProgressBars(true);

    const showNextSlide = () => {
      if (!this.isHovering) return;

      this.slides[this.currentIndex].classList.remove('is-active');
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      this.slides[this.currentIndex].classList.add('is-active');
      this.updateProgressBars(this.currentIndex);

      this.hoverTimeout = setTimeout(showNextSlide, 1000);
    };

    this.updateProgressBars(this.currentIndex);
    this.hoverTimeout = setTimeout(showNextSlide, 1000);
  }

  resetGallery() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
    this.slides.forEach((slide, index) => {
      slide.classList.toggle('is-active', index === 0);
    });
    this.currentIndex = 0;
    this.updateProgressBars(0);
    this.showProgressBars(false);
  }

  updateProgressBars(activeIndex) {
    this.progressBars.forEach((bar, idx) => {
      bar.classList.toggle('filled', idx === activeIndex);
    });
  }

  showProgressBars(show) {
    const bars = this.querySelector('.gallery-progress-bars');
    if (bars) bars.style.opacity = show ? '1' : '0';
  }
}

if (!customElements.get('product-card-gallery')) {
  customElements.define('product-card-gallery', ProductCardGallery);
}
